"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconVIP = function SvgIconVIP(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "v i p icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'V I P Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 18h4.057l5.337 14.757L16.784 18h4.03L13.3 37.876H9.515L2 18zm21.101 0h3.894v19.876h-3.894V18zm15.439 0c1.107 0 2.119.186 3.035.558a7.02 7.02 0 012.356 1.539 6.98 6.98 0 011.524 2.3c.363.88.545 1.82.545 2.818a7.249 7.249 0 01-2.07 5.106 7.085 7.085 0 01-2.355 1.565c-.916.381-1.937.572-3.063.572h-3.948v5.418h-3.866V18h7.842zm-.245 3.512h-3.73v7.38h3.73c.562 0 1.08-.092 1.552-.273a3.53 3.53 0 001.211-.763c.336-.326.595-.717.776-1.17.182-.454.272-.944.272-1.47a3.99 3.99 0 00-.272-1.498 3.345 3.345 0 00-.776-1.171 3.53 3.53 0 00-1.211-.762 4.289 4.289 0 00-1.552-.273z"
  }));
};

var _default = SvgIconVIP;
exports.default = _default;